import { render } from "./BasicTutorial.vue?vue&type=template&id=78747720&scoped=true"
import script from "./BasicTutorial.vue?vue&type=script&lang=js"
export * from "./BasicTutorial.vue?vue&type=script&lang=js"

import "./BasicTutorial.vue?vue&type=style&index=0&id=78747720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78747720"]])

export default __exports__